import { doc, getDoc } from 'firebase/firestore';
import { IMaterialExposure, INetExposure } from '../sp-types/netExposureType';
import { db } from './firebase';
import { getItem, saveItem } from './genericFB';

const COLLECTION = 'exposure';
export async function getExposureById(accountId: string): Promise<INetExposure | null> {
  const docRef = doc(db, COLLECTION, accountId);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data() as INetExposure;
  }

  console.log('No matching documents found.');
  return null;
}

const emptyExposure = {
  financialPositions: 0,
  futureOrder: 0,
  inventorySum: 0,
  futureExpCalendar: [],
  positionExpCalendar: [],
  inventoryCalendar: { date: { month: 0, year: 0 }, value: 0 },
} as IMaterialExposure;

export async function clearExposure(accountId: string, formulaIds?: string[]): Promise<void> {
  const exposure = await getItem<INetExposure>(accountId, COLLECTION);

  if (exposure) {
    const materials = formulaIds ? formulaIds : Object.keys(exposure?.materialsExposure || {});

    const materialsExposure = Object.fromEntries(materials.map((formulaId) => [formulaId, emptyExposure]));

    await saveItem<INetExposure>(accountId, { ...exposure, materialsExposure }, COLLECTION);
  }
}

export const createExposure = async (accountId: string, formulaIds?: string[]): Promise<void> => {
  const exposure = await getItem<INetExposure>(accountId, COLLECTION);

  if (exposure) {
    const materials = formulaIds ? formulaIds : Object.keys(exposure?.materialsExposure || {});

    const materialsExposure = Object.fromEntries(materials.map((formulaId) => [formulaId, emptyExposure]));

    await saveItem<INetExposure>(accountId, { ...exposure, materialsExposure }, COLLECTION);
  } else {
    await saveItem<INetExposure>(accountId, { materialsExposure: {}, updatedAt: new Date() }, COLLECTION);
  }
};

export const createMissingExposure = async (accountId: string, allMaterialIds: string[]): Promise<void> => {
  const exposure = await getItem<INetExposure>(accountId, COLLECTION);

  const materialsExposure = Object.fromEntries(
    allMaterialIds.map((mId) => [mId, exposure?.materialsExposure[mId] || emptyExposure]),
  );

  await saveItem<INetExposure>(accountId, { ...exposure, materialsExposure, updatedAt: new Date() }, COLLECTION);
};
